import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { ViewWrapper, Img } from 'libs/rendering/styles';

export const ImageViewer = observer(({ file, isPreview, width }) => {
  return (
    <ViewWrapper isPreview={isPreview} width={width}>
      <meta itemProp='name' content={file?.filename || 'Pending file'}></meta>
      <meta itemProp='uploadDate' content={file?.fileLastModified}></meta>
      <meta itemProp='encodingFormat' content={file?.mimeType}></meta>
      <Img src={file?.permalink} itemprop='contentUrl' />
    </ViewWrapper>
  );
});

ImageViewer.propTypes = {
  file: PropTypes.object,
  isPreview: PropTypes.bool,
  width: PropTypes.string,
};
